import React, { useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import useEasterEgg from "utils/hooks/useEasterEgg";
import PageHeaders from "../common/PageHeaders";
import Menu from "../common/Menu";
import Header from "../components/Header";
import Footer from "../components/Footer";
import arman from "../images/peeps/arman.webp";
import brad from "../images/peeps/brad.webp";
import dmitry from "../images/peeps/dmitry.webp";
import garrett from "../images/peeps/garrett.webp";
import karin from "../images/peeps/karin.webp";
import scott from "../images/peeps/scott.webp";
import sreekar from "../images/peeps/sreekar.webp";
import viktor from "../images/peeps/viktor.webp";

const peeps = [
  { name: "arman", image: arman },
  { name: "brad", image: brad },
  { name: "dmitry", image: dmitry },
  { name: "garrett", image: garrett },
  { name: "karin", image: karin },
  { name: "scott", image: scott },
  { name: "sreekar", image: sreekar },
  { name: "viktor", image: viktor },
];

const allEggs = peeps.map((peep) => ({
  string: peep.name,
  image: peep.image,
  logMessage:
    peep.name === "viktor"
      ? `still here in spirit`
      : `${peep.name}, we miss you!`,
}));

const About = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { eggs } = useEasterEgg(allEggs);

  return (
    <>
      <PageHeaders type="faq" />
      <div className="flex flex-col h-full" id="outer-container">
        <div className={`relative ${menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={(state) => {
              setMenuOpen(state.isOpen);
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="topSection" id="page-wrap" style={{ background: "#000000" }}>
          <div className="headerBar">
            <Header siteTitle="FAQ" />
          </div>
          <div className="mainContent flex mt-12 lg:mt-20">
            <main className="w-full text-dark pt-16">
              <section className="mb-5 px-10 max-w-page text-center py-5">
                <h1 className="text-3xl md:text-5xl  font-extrabold w-10/12 mx-auto text-white">
                  Frequently Asked Questions
                </h1>
                <p className="md:text-2xl font-light mt-2 w-full md:w-8/12 mx-auto text-white">
                  Find answers to common questions.
                </p>
              </section>

              <section className="max-w-page">
                <div>
                  <Accordion allowZeroExpanded>
                    <div className="w-11/12 md:w-11/12 lg:w-8/12 mx-auto mb-20">
                      {/* TomoBoost ========================================= */}
                      <h3 className="pt-8 pb-3 text-3xl font-bold text-primary">
                        TomoBoost
                      </h3>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                What is TomoBoost?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <a href="https://www.tomoboost.com/" className="underline">Click here to find out!</a>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      {/* The card
            ========================================= */}

                      <h3 className="pt-8 pb-3 text-3xl font-bold text-primary">
                        The card
                      </h3>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                What is a Tomo card?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Here at Tomo, we know you are worth more than
                                just a credit score. That’s why we created a
                                solution to tackle the flaws of the everyday
                                credit card. You can apply to Tomo without a
                                credit score or prior credit history.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                What type of card is Tomo?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Your Tomo card is a charge card with a 7-day
                                automatic payment feature to help keep your
                                credit utilization low.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Why should I use Tomo instead of my debit card?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                With Tomo, we're helping you build your credit
                                score. On top of that, you receive access to the
                                MasterCard World Elite benefits. What does your
                                debit card do for you? Exactly our point.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Where can I use my card?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Our card holders can use their cards online and
                                with millions of merchants across 200 countries
                                where Mastercard is accepted.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Will applying affect my credit score?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                No. Whether your Tomo application was approved
                                or rejected, it will never affect your credit
                                score.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Can I get a Tomo card if I have no credit score?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Of course! That’s why we created Tomo. We wanted
                                to create a card that everyone has the
                                opportunity to access.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                I’m not a U.S. citizen, can I still sign up?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Of course! To apply for Tomo all you need is a
                                valid SSN or ITIN and a government issued ID.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Why do I need to link my bank account?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                To sustain a card that doesn’t require a credit
                                score or a deposit, we use alternative data
                                sources, such as information from your bank
                                account, to process your application. We use
                                third-party service providers, such as
                                Finicity (a Mastercard company), to link your
                                bank account. Tomo does not store your bank
                                account login details.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                What will my spending power be?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                We cannot pre-determine your exact spending
                                power. What we can tell you is that Tomo looks
                                at your bank accounts and other factors to help
                                determine your spending power. In order to
                                obtain the highest limit, we recommend that you
                                connect all bank accounts or the account with
                                the highest balance.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                What are the payment terms?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                You must pay your balance in full each cycle.
                                You can also enroll in our 7-day automatic
                                payment feature to ensure timely payment of your
                                balance.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                How does Autopay work and can I change its
                                schedule?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                If you enroll in our 7-day automatic payment
                                feature, or Autopay, we will initiate a payment
                                one day each week for your total charges during
                                the previous week. The day-of-week (your
                                "Autopay day") will be displayed on your
                                dashboard. Payments will be initiated on the
                                next business day if your Autopay day is a
                                holiday. We do not allow changes to your Autopay
                                day at this time.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Can I carry a balance?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>No.</p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                What happens if I don't pay off my balance?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Your card will be frozen till the previous
                                period balance is paid in full.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                How does Tomo help build my credit score?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Tomo's smart payments help you make payments on
                                time, every time. Keep your balances low (and
                                your credit utilization healthy!) with weekly
                                autopay. Sustained on-time payments and low
                                credit utilization build your credit score over
                                time.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Can I re-apply for a card if I was rejected?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                As of right now you can not apply after being
                                rejected. We hope to build out this feature
                                soon. If you think you were denied by mistake
                                please contact our Customer Support.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                How long does it take to get my card?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Once approved, your card should arrive in 7-10
                                business days, encased in a Tomo-branded black
                                envelope. If your card does not show up by then,
                                please get in touch with our Customer Support.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                How do I activate my card?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Activate your card from the TomoCredit app or
                                your web dashboard.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                What should I do if I didn't receive my card?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Please contact our Customer Support online or
                                call +1 (866) 432-7695
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                How do I increase my spending power?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                There are several factors that play into an
                                increase of your spending power.
                                <ul>
                                  <li>
                                    Linking your bank account with the highest
                                    balance
                                  </li>
                                  <li>Linking multiple bank accounts</li>
                                  <li>Consistent on time payments</li>
                                </ul>
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                When do I receive my statements?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Statements are issued on the 7th of every month.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      {/* The company
            ========================================= */}

                      <h3 className="pt-8 pb-3 text-3xl font-bold text-primary">
                        The company
                      </h3>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Why is everyone switching to Tomo?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                People are tired of an old and outdated credit
                                card system where they’re judged by their credit
                                score. We decided we wanted to be the solution
                                to that problem. We require no credit history or
                                credit score for you to apply. You probably
                                won’t find a simpler, smarter, or more rewarding
                                card than Tomo.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                How does Tomo make money?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Tomo receives a small fee from the merchant for
                                every purchase made with your Tomo card.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>

                      {/* Your Security
            ========================================= */}

                      <h3 className="pt-8 pb-3 text-3xl font-bold text-primary">
                        Your security
                      </h3>

                      {/* <div class="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                Why do you need my social security number?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                Your security is important to us. We require
                                this information in order to make sure you are
                                who you say you are in addition to preventing
                                identity theft. We use a secured 3rd party
                                called Alloy  to
                                handle all identity verification. Synapse does
                                not sell or rent your data to anyone, including
                                marketers or other third parties, and does not
                                use your data for commercial purposes other than
                                identity verification, financial loss
                                mitigation, and regulatory compliance.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
          </div>

                      <div class="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                How am I protected from fraud?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                We use Synapse’s machine learning and facial
                                recognition to verify the legitimacy of your
                                identification documents. When a new user
                                account is created it is Synapse
                                programmatically compares user’s vectors against
                                others in its database to help detect potential
                                identity theft.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div> */}

                      <div className="w-full px-1 mb-1">
                        <div className="accordion-wrap">
                          <AccordionItem>
                            <AccordionItemHeading>
                              <AccordionItemButton>
                                How do I dispute a charge?
                              </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                              <p>
                                To dispute a charge it must be done in writing.
                                You can dispute a charge by clicking on the
                                transaction in your dashboard for further
                                details and clicking “dispute” in the bottom
                                left corner. From there please fill out the form
                                with further details. Once submitted, cases may
                                take 60 or more days to resolve.
                              </p>
                            </AccordionItemPanel>
                          </AccordionItem>
                        </div>
                      </div>
                    </div>
                  </Accordion>
                </div>
              </section>
            </main>
          </div>
        </div>
        {eggs}
        <Footer />
      </div>
    </>
  );
};

export default About;
